<template>
  <div>
    <AiChatWidgetChatBubble
      v-if="aiChatEnabled"
      :active-state="bubbleState"
      @state-change="handleStateChange"
      @first-hover="handleFirstHover"
    />
    <AiChatWidgetChatDrawer
      :is-open="isOpen"
      :active-state="bubbleState"
      :should-load="loadDrawer"
      :client-info="clientInfo"
      @state-change="handleStateChange"
      @close="handleDrawerClose"
    />
  </div>
</template>

<script setup>
import { useStore } from 'vuex';

import { getStreamConversation, deleteSession } from '~/helpers/api/stream';

defineProps({
  clientInfo: {
    type: Object,
    required: true,
  },
});

const chat = useChat();
const store = useStore();
const secondaryOrgId = store.state.secondaryOrgId;
const writableApi = useRuntimeConfig().public.WRITABLE_BASE_API_URL;
const { sessionId: sId } = useSession();

if (!chat.isConnected.value) {
  try {
    const config = {
      endpoint: writableApi,
      secondaryOrgId,
      sessionId: sId.value,
    };

    await chat.connectWithProvider(async () => await getStreamConversation(config), config);
  } catch (e) {
    console.error("Can't connect to Stream", e);
  }
}

const { bubbleState, aiChatEnabled, isOpen, loadDrawer, handleStateChange, handleDrawerClose, handleFirstHover } =
  useAiChatWidget();

const handlePageUnload = () => {
  if (chat.isConnected.value && sId.value) {
    void deleteSession({
      endpoint: writableApi,
      secondaryOrgId,
      sessionId: sId.value,
    });
  }
};

onMounted(() => {
  window.addEventListener('pagehide', handlePageUnload);
});

onUnmounted(() => {
  window.removeEventListener('pagehide', handlePageUnload);
});
</script>
